module.exports = __webpack_public_path__ + "img/large.fdac3ebe.png";